//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sessionLogin } from "@/api";
import Cookies from "@/utils/cookie";

export default {
  name: "InternalLogin",
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      isSubmitting: false,
      errorMessage: "",
    };
  },
  methods: {
    async handleLogin() {
      this.errorMessage = "";

      if (!this.form.username || !this.form.password) {
        this.errorMessage = "请输入账号和密码";
        return;
      }

      this.isSubmitting = true;

      try {
        const res = await sessionLogin({
          username: this.form.username,
          password: this.form.password,
        });

        if (res.data.code !== 0) {
          this.errorMessage = res.data.msg || "登录失败，请检查账号或密码";
          return;
        }

        Cookies.setToken(res.data.authToken);
        this.$store.commit("setInfo");
        this.$toast.success("登录成功");

        const redirect = this.$route.query.redirect || "/";
        this.$router.replace(redirect);
      } catch (error) {
        this.errorMessage = "登录失败，请稍后重试";
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
